<article class="tw-flex tw-flex-wrap tw-gap-2">
  @for (tag of tags; track tag) {
    <p
      class="tw-m-0 tw-rounded-md tw-border tw-border-gray-400 tw-px-2 tw-py-1 tw-font-body tw-text-sm tw-font-normal tw-text-gray-400"
      [class]="tag"
    >
      {{ 'campaign.' + tag | translate }}
    </p>
  }
  @if (!tags.length) {
    <p class="tw-m-0 tw-font-bold">-</p>
  }
</article>
